export default __webpack_public_path__ + "static/sakhalin_small-57e10c76d17f46f48e2b79ddf83a644e.jpg";